import React, { ChangeEvent } from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import COLOR from '@CONSTANTS/COLOR.constant';

import { Search } from 'lucide-react';

import CircularProgressIndicator from '@COMPONENTS/SHARED/CircularProgressIndicator';

import styles from './SearchInput.module.scss';

const cx: CX = classnames.bind(styles);

function SearchbarInput(props: Props) {
    const {
        isLoading,
        placeholder,
        value,
        onChange,
        onFocus,
        iconWrapper,
        inputWrapper,
        hideClearIcon,
    } = props;

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        onChange(event.target.value);
    }

    return (
        <div className={cx('searchbar-input')}>
            <div className={cx('input-wrapper', inputWrapper)}>
                <div className={cx('icon', iconWrapper)}>
                    {
                        isLoading
                            ? (
                                <CircularProgressIndicator
                                    size={18}
                                    thickness={2}
                                    color={COLOR['marriott-light-grey']}
                                />
                            ) : (
                                <Search size={16} strokeWidth={2} />
                            )
                    }
                </div>
                <input
                    type="text"
                    value={value}
                    onChange={handleChange}
                    onFocus={onFocus}
                    placeholder={placeholder}
                />
                {
                    value.length > 0 && !hideClearIcon
                    && (
                        <button
                            type="button"
                            className={cx('clear-input-button', 'clear-button')}
                            onClick={() => {
                                onChange('');
                            }}
                        >
                            &times;
                        </button>
                    )
                }
            </div>
        </div>
    );
}

SearchbarInput.defaultProps = {
    iconWrapper: '',
    inputWrapper: '',
    hideClearIcon: false,
};

SearchbarInput.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    iconWrapper: PropTypes.string,
    inputWrapper: PropTypes.string,
    hideClearIcon: PropTypes.bool,
};

type Props = InferProps<typeof SearchbarInput.propTypes>;

export default SearchbarInput;
